'use client'

import { createContext } from 'react'

export interface LocaleContextValue {
  language: string
  locale: string
  localePrefix: string
  isImplicit: boolean
}

const LocaleContext = createContext<LocaleContextValue>({
  language: 'en',
  locale: 'en-us',
  localePrefix: '',
  isImplicit: false
})

export default LocaleContext
